<script setup lang="ts">
import { formatCurrency } from "shared/helpers";
import { capitalize } from "vue";

const { t } = useI18n();

useSeoMeta({
	title: () => t("meta.faq.title"),
	ogTitle: () => t("meta.faq.ogTitle"),
	description: () => t("meta.faq.description"),
	ogDescription: () => t("meta.faq.ogDescription")
});

useSchemaOrg([
	defineWebPage({
		"@type": "FAQPage"
	}),
	defineQuestion({
		name: () => capitalize(t("faqQuestion1Title")),
		acceptedAnswer: () => `${t("faqQuestion1Description")} "${t("checkoutOrder")}"
${t("faqQuestion1Description3")}`
	}),
	defineQuestion({
		name: () => capitalize(t("faqQuestion2Title")),
		acceptedAnswer: () => `${t("faqQuestion2Description")}
${t("faqQuestion2Description2")}}`
	}),
	defineQuestion({
		name: () => capitalize(t("delivery")),
		acceptedAnswer: () => `${t("faqQuestion3Description")}
${t("faqQuestion3Description2")} ${formatCurrency(50)} ${t("faqQuestion3Description3")}
${t("faqQuestion3Description2")} ${formatCurrency(55)} ${t("faqQuestion3Description4")}
${capitalize(t("faqQuestion3Description5"))}`
	}),
	defineQuestion({
		name: () => capitalize(t("faqQuestion4Title")),
		acceptedAnswer: () => `${t("faqQuestion4Description")} 
${t("faqQuestion4Description")}"
${t("faqQuestion4Description2")}
${t("faqQuestion4Description3")}
${t("faqQuestion4Description4")}
${t("faqQuestion4Description5")}
${t("faqQuestion4Description6")}
${t("faqQuestion4Description7")} ${t("faqQuestion4Description8")}
${t("faqQuestion4Description9")}
${t("faqQuestion4Description10")}`
	})
]);
</script>

<template>
	<section class="box-content pt-10 pb-11 px-6 max-w-[1024px] m-auto xs:px-4">
		<h1 class="font-bold text-3xl uppercase">
			{{ t('faqTitle') }}
		</h1>
		<article
			class="mt-8"
		>
			<AppAccordion
				:title="capitalize(t('faqQuestion1Title'))"
				opened
			>
				<template #description>
					<div class="flex flex-col gap-y-2">
						<div>{{ t('faqQuestion1Description') }} <b class="font-semibold">"{{ t('checkoutOrder') }}"</b>.</div>
						<div>{{ t('faqQuestion1Description3') }}</div>
					</div>
				</template>
			</AppAccordion>
		</article>
		<article
			class="mt-5"
		>
			<AppAccordion
				:title="capitalize(t('faqQuestion2Title'))"
			>
				<template #description>
					<div class="flex flex-col gap-y-2">
						<div>{{ t('faqQuestion2Description') }}</div>
						<div>{{ t('faqQuestion2Description2') }}</div>
					</div>
				</template>
				<template #image>
					<NuxtImg
						class="m-auto"
						src="img/cake-topper-size-guide.webp"
						:width="640"
						alt="image"
					/>
				</template>
			</AppAccordion>
		</article>
		<article
			class="mt-5"
		>
			<AppAccordion
				:title="capitalize(t('delivery'))"
			>
				<template #description>
					<div class="flex flex-col gap-y-2">
						<div>{{ capitalize(t('faqQuestion3Description')) }}</div>
						<div class="flex flex-col">
							<div>{{ capitalize(t('cost')) }}:</div>
							<div>{{ t('faqQuestion3Description2') }} <b class="font-semibold">{{ formatCurrency(60) }}</b> {{ t('faqQuestion3Description3') }}</div>
							<div>{{ t('faqQuestion3Description2') }} <b class="font-semibold">{{ formatCurrency(70) }}</b> {{ t('faqQuestion3Description4') }}</div>
						</div>
						<div>{{ capitalize(t('faqQuestion3Description5')) }}</div>
					</div>
				</template>
			</AppAccordion>
		</article>
		<article
			class="mt-5"
		>
			<AppAccordion
				:title="capitalize(t('faqQuestion4Title'))"
			>
				<template #description>
					<div class="flex flex-col gap-y-4 font-bold">
						<div>{{ t('faqQuestion4Description') }}</div>
						<div>{{ t('faqQuestion4Description2') }}</div>
						<div>{{ t('faqQuestion4Description3') }}</div>
						<div>{{ t('faqQuestion4Description4') }}</div>
						<div>{{ t('faqQuestion4Description5') }}</div>
						<div>{{ t('faqQuestion4Description6') }}</div>
						<div>
							<div>{{ t('faqQuestion4Description7') }}</div>
							<div class="font-normal">
								{{ t('faqQuestion4Description8') }}
							</div>
						</div>
						<div>{{ t('faqQuestion4Description9') }}</div>
						<div>{{ t('faqQuestion4Description10') }}</div>
						<div class="mt-5 font-normal">
							<div>
								{{ t('faqQuestion4Description11') }}
							</div>
							<div>
								{{ t('faqQuestion4Description12') }}
							</div>
						</div>
					</div>
				</template>
			</AppAccordion>
		</article>
	</section>
</template>
